__turbopack_context__.v({
  "className": "nanum_myeongjo_301588dc-module___Tyz-a__className",
});
